import React, { useEffect, useState } from "react";
import "./home.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";

import { isloading } from "../redux/reducer/LoadingReducer";
import AxiosInstance from "../Utility/AxiosInstance";
const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [recentActivity, setRecentActivity] = useState({});
  const [totalImages, setTotalImages] = useState(0);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [carouselImages, setCarouselImages] = useState(0);
  const [totalLinks, setTotalLinks] = useState(0);
  const [data, setData] = useState({ pending: 0, verified: 0, rejected: 0 });
  const role = JSON.parse(sessionStorage.getItem("$details"))?.role;
  const fetchDashboardData = async () => {
    const token = sessionStorage.getItem("userToken");

    if (!token) return navigate("/login");
    dispatch(isloading());
    try {
      if (role === "ADMIN") {
        const res = await AxiosInstance.get(`${BaseUrl}/api/dashboard/cms/counts`, {
          headers: { "Content-Type": "application/json", Authorization: token },
        });

        if (res.data.status == 200) {
          setTotalImages(
            res.data.data.galleryCounts.reduce(
              (acc, item) => acc + item.count,
              0
            )
          );
          setTotalNotifications(
            res.data.data.notificationCounts.reduce(
              (acc, item) => acc + item.count,
              0
            )
          );
          setCarouselImages(res.data.data.galleryCounts[0].count || 0);
          setTotalLinks(
            res.data.data.linkCounts.reduce((acc, item) => acc + item.count, 0)
          );
        } else {
          toast.error("Failed to fetch data.");
        }
      }

      if (role === "DISTRICT_ADMIN") {
        const res = await AxiosInstance.get(
          `${BaseUrl}/api/dashboard/district/counts`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          }
        );

        if (res.data.status == 200) {
          const counts = res.data.data || {};
          setData({
            pending: Number(counts.pending) || 0,
            verified: Number(counts.approved ?? counts.verified) || 0,
            rejected: Number(counts.rejected) || 0,
          });
        } else {
          toast.error("Failed to fetch data.");
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      dispatch(isloading());
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  return (
    <div className="home-dashboard">
      <h3>Dashboard</h3>
      <div className="dashboard-stats">
        {role === "ADMIN" && (
          <>
            <div className="stat-card">
              <h3>Total Images</h3>
              <p>{totalImages || 0}</p>
            </div>
            <div className="stat-card">
              <h3>Total Notifications</h3>
              <p>{totalNotifications || 0}</p>
            </div>
            <div className="stat-card">
              <h3>Carousel Images</h3>
              <p>{carouselImages || 0}</p>
            </div>
            <div className="stat-card">
              <h3>Total Links</h3>
              <p>{totalLinks || 0}</p>
            </div>{" "}
          </>
        )}
        {role === "DISTRICT_ADMIN" && (
          <>
            <div
              className="stat-card"
              onClick={() => navigate("/dashboard/registration-data")}
            >
              <h3>Total Applications</h3>
              <p className="text-center">
                {(data.pending || 0) + (data.verified || 0) + (data.rejected || 0)}
              </p>
            </div>
            <div
              className="stat-card"
              onClick={() =>
                navigate("/dashboard/district-registration-data", {
                  state: { status: "PENDING"},
                })
              }
            >
              <h3>Pending Applications</h3>
              <p className="text-center">{data.pending || 0}</p>
            </div>
            <div className="stat-card" onClick={() =>
                navigate("/dashboard/district-registration-data", {
                  state: { status: "APPROVED"},
                })
              }>
              <h3>Approved Applications</h3>
              <p className="text-center">{data.verified || 0}</p>
            </div>
            <div className="stat-card" onClick={() =>
                navigate("/dashboard/district-registration-data", {
                  state: { status: "REJECTED"},
                })
              }>
              <h3>Rejected Applications</h3>
              <p className="text-center">{data.rejected || 0}</p>
            </div>{" "}
          </>
        )}
      </div>

      {role === "ADMIN" && (
      <div className="recent-activity">
        <h2>Recent Activity</h2>
        <hr />
        {recentActivity ? (
          <div className="timeline-container">
            <div className="timeline-date-group">
              <div className="timeline-indicator">
                <div className="timeline-dot"></div>
                <div className="timeline-line"></div>
              </div>

              <div className="timeline-content">
                <div className="timeline-date">
                  <h5>05/02/2025</h5>
                </div>
                <div className="timeline-tasks">
                  <div className="timeline-card">
                    <p className="timeline-card-action">
                      <strong>Image</strong> Uploaded by <strong>Admin</strong>{" "}
                      in gallery.
                    </p>
                    <div className="timeline-card-footer float-right">
                      <span className="timeline-card-date">
                        05/02/2025 01:15:34 pm
                      </span>
                      <span className="timeline-card-assignee new">New</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="timeline-date-group">
              <div className="timeline-indicator">
                <div className="timeline-dot"></div>
                <div className="timeline-line"></div>
              </div>

              <div className="timeline-content">
                <div className="timeline-date">
                  <h5>03/02/2025</h5>
                </div>
                <div className="timeline-tasks">
                  <div className="timeline-card">
                    <p className="timeline-card-action">
                      <strong>Notification</strong> Updated by{" "}
                      <strong>Admin</strong> in Home Page.
                    </p>
                    <div className="timeline-card-footer float-right">
                      <span className="timeline-card-date">
                        03/02/2025 12:15:34 pm
                      </span>
                      <span className="timeline-card-assignee update">
                        Update
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="timeline-date-group">
              <div className="timeline-indicator">
                <div className="timeline-dot"></div>
                <div className="timeline-line"></div>
              </div>

              <div className="timeline-content">
                <div className="timeline-date">
                  <h5>01/02/2025</h5>
                </div>
                <div className="timeline-tasks">
                  <div className="timeline-card">
                    <p className="timeline-card-action">
                      <strong>Link</strong> Deleted by <strong>Admin</strong> in
                      Home Page.
                    </p>
                    <div className="timeline-card-footer float-right">
                      <span className="timeline-card-date">
                        01/02/2025 12:15:34 pm
                      </span>
                      <span className="timeline-card-assignee deleted">
                        Delete
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p>No recent activity</p>
        )}
      </div>
      )}
    </div>
  );
};

export default Home;
